import React, { Component } from "react";
import { Link } from "react-router-dom";

class SeekerDenier extends Component {
  render() {
    
    return (
        <section id="pageNotFound">
        <div className="container pt--100 pt_lg--120 ">
          <div id="pagenotfound" className="row">
            <div className="pagenotfound ">
              <div className="notfound-404"></div>
              <h1>403</h1>
              <h2>OOPS! ACCESS DENIED</h2>
              <p>
                Sorry, to create a resume, you must first create a Job Seeker Account.
              </p>
              <p><Link to="/signup">Create a Job Seeker Account</Link> or <Link to="/signin">Signin as Job Seeker</Link></p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default SeekerDenier;
